import { useCallback, useState } from "react";
import { Outlet } from "react-router";
import {
	SidebarInset,
	SidebarProvider,
	SidebarTrigger,
} from "@/components/ui/sidebar";
import ChatSidebar from "./ChatSidebar";
import { GlobalSearchDialog } from "./GlobalSearchDialog";

export default function ChatLayout() {
	const [searchOpen, setSearchOpen] = useState(false);

	// ⌘K / Ctrl+K opens the global search palette. Callback-ref window listener
	// (no useEffect) — consistent with the in-thread ⌘F handler in ChatMessages.
	const hotkeyRef = useCallback((node: HTMLDivElement | null) => {
		if (!node) return;
		const handler = (e: KeyboardEvent) => {
			if ((e.metaKey || e.ctrlKey) && (e.key === "k" || e.key === "K")) {
				e.preventDefault();
				setSearchOpen(true);
			}
		};
		window.addEventListener("keydown", handler);
		return () => window.removeEventListener("keydown", handler);
	}, []);

	return (
		<SidebarProvider>
			<div ref={hotkeyRef} aria-hidden className="hidden" />
			<ChatSidebar onOpenSearch={() => setSearchOpen(true)} />
			<SidebarInset className="relative flex h-svh flex-col overflow-hidden">
				<div className="absolute top-3 left-3 z-20">
					<SidebarTrigger className="border bg-background shadow-sm hover:bg-muted" />
				</div>
				<Outlet />
			</SidebarInset>
			<GlobalSearchDialog open={searchOpen} onOpenChange={setSearchOpen} />
		</SidebarProvider>
	);
}
